import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import serviceEndpoints from '../../../config/serviceEndpoints';
import staticGateway from '../../../config/service';
import { getQueryParams } from '../../../utils/utils';

export const getTrainersList = createAsyncThunk('/api/superAdmin/user', async (data, { rejectWithValue }) => {
    const body = { ...data, platform: 'web' };
    try {
        const response = await staticGateway.get(
            `${serviceEndpoints.getTableData}/Trainer?${getQueryParams(data)}`,
            body
        );
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

export const deleteRow = createAsyncThunk('/api/superAdmin/deleteTrainer', async (data, { rejectWithValue }) => {
    const body = { ...data, platform: 'web' };
    try {
        const response = await staticGateway.delete(`${serviceEndpoints.deleteTableRow}/${data}`, body);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

const slice = createSlice({
    name: 'trainer',
    initialState: {
        resMsg: '',
        trainerData: {},
        trainersList: {},
        isLoading: false,
        isDeleted: false,
    },

    extraReducers: (builder) => {
        builder
            .addCase(getTrainersList.pending, (state) => {
                state.isLoading = true;
                state.resMsg = '';
                state.trainerData = {};
                state.isDeleted = false;
            })
            .addCase(getTrainersList.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.trainerData = {};
                state.trainersList = {};
            })
            .addCase(getTrainersList.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.trainerData = payload.result || null;
                if (payload.result.rows) {
                    state.trainersList = payload.result.rows;
                } else state.trainersList = current(state).trainersList;
            })
            .addCase(deleteRow.pending, (state) => {
                state.isLoading = true;
                state.resMsg = '';
                state.isDeleted = false;
            })
            .addCase(deleteRow.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.isDeleted = false;
            })
            .addCase(deleteRow.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload.message;
                state.isDeleted = payload?.statusCode === 200 && payload.message;
            });
    },
});

export default slice.reducer;
